import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import styled from 'styled-components'
import shortid from 'shortid'
import get from 'lodash/get'
import find from 'lodash/find'
import orderBy from 'lodash/orderBy'
import moment from '../../../../lib/moment.js'
import { statusColor, approveStatus } from '../../helpers/color'
import { time_sheet_approval_header, FONTS } from '../../../../constants'
import arrow_down_black from '../../../../static/images/arrow-down-black.svg'
import arrow_up_black from '../../../../static/images/arrow-up-black.svg'
import * as timesheetHelper from '../../helpers/timesheet'
import * as CONSTANTS from '../../constants'

const createTimesheetApprovalList = (timesheetApproval, users) => {
  const newTimesheetApproval = timesheetApproval.map(item => {
    const myStatus = find(item.approve_status, {
      approver_id: localStorage.getItem('_id'),
    })
    const data = timesheetHelper.findUserData(item.user_id, users)
    let newApproval = {}
    newApproval = item
    newApproval.status = item.status
    newApproval.month = moment(get(item, 'timesheet_snapshot.month')).format('MMMM')
    newApproval.month_no = moment(get(item, 'timesheet_snapshot.month')).format('MM')
    newApproval.year = moment(get(item, 'timesheet_snapshot.month')).format('YYYY')
    newApproval.emp_code = data.emp_code
    newApproval.first_name = data.first_name
    newApproval.last_name = data.last_name
    newApproval.nick_name = data.nick_name
    newApproval.lob_name = data.lob_name
    newApproval.department_name = data.department_name
    newApproval.my_status = get(myStatus, 'status', '')
    return newApproval
  })
  return newTimesheetApproval
}

const filterTimesheetApproval = (timesheetApproval, searchApproval) => {
  return timesheetApproval.filter(item => {
    const emp_code = get(item, 'emp_code', '').toLowerCase()
    const status = get(item, 'status', '').toLowerCase()
    const name = (`${get(item, 'first_name', '')} ${get(item, 'last_name', '')}`).toLowerCase()
    const lob = get(item, 'lob_name', '').toLowerCase()
    const department = get(item, 'department_name', '').toLowerCase()
    const month = get(item, 'month', '').toLowerCase()
    const year = get(item, 'year', '').toLowerCase()
    const my_status = get(item, 'my_status', '').toLowerCase()
    const search = searchApproval.toLowerCase()
    return status.includes(search) || emp_code.includes(search) || name.includes(search)
      || lob.includes(search) || department.includes(search) || month.includes(search)
      || year.includes(search) || my_status.includes(search)
  })
}

export const ApprovalTable = class extends React.Component {
  state={ sort_order: false, sort_column: 7 }

  handleClickSort(column) {
    if (column === this.state.sort_column) {
      this.setState({
        sort_order: !this.state.sort_order,
      })
    } else {
      this.setState({
        sort_order: false,
        sort_column: column,
      })
    }
  }

  sortTimesheetApproval = (data) => {
    const { sort_column } = this.state
    const sort_order = this.state.sort_order ? 'asc' : 'desc'
    if (sort_column === 0) {
      return orderBy(data, (item) => {
        const order = {
          'PENDING': 1,
          'APPROVED': 2,
          'CANCEL': 3,
          'REJECTED': 4,
        }
        return order[item.status]
      }, sort_order)
    } else if (sort_column === 1) return orderBy(data, ['month_no', 'year'], [sort_order, sort_order])
    else if (sort_column === 2) return orderBy(data, ['year', 'month_no'], [sort_order, sort_order])
    else if (sort_column === 3) return orderBy(data, 'emp_code', sort_order)
    else if (sort_column === 4) return orderBy(data, ['first_name', 'last_name', 'nick_name'], sort_order)
    else if (sort_column === 5) return orderBy(data, 'lob_name', sort_order)
    else if (sort_column === 6) return orderBy(data, 'department_name', sort_order)
    else if (sort_column === 7) return orderBy(data, 'created', sort_order)
    else if (sort_column === 8) {
      return orderBy(data, (item) => {
        const order = {
          'PENDING': 1,
          'APPROVED': 2,
          'CANCEL': 3,
          'REJECTED': 4,
        }
        return order[item.my_status]
      }, sort_order)
    }
    return data
  }

  render() {
    const { sort_order, sort_column } = this.state
    const { timesheets, handleClickRow } = this.props
    const { searchApproval } = this.props
    const users = get(timesheets, 'users')
    let timesheetApprovals = get(this.props, 'timesheetApprovals', [])
    timesheetApprovals = createTimesheetApprovalList(timesheetApprovals, users)
    timesheetApprovals = filterTimesheetApproval(timesheetApprovals, searchApproval)

    switch (get(this.props, 'filterButton')) {
      case 3:
        timesheetApprovals = timesheetApprovals.filter(
          (element) => element.my_status === CONSTANTS.PENDING)
        break
      case 4:
        timesheetApprovals = timesheetApprovals.filter(
          (element) => element.my_status === CONSTANTS.APPROVED)
        break
      case 5:
        timesheetApprovals = timesheetApprovals.filter(
          (element) => element.my_status === CONSTANTS.REJECTED)
        break
      default:
        break
    }

    return (
    /* eslint no-underscore-dangle: 0 */
      <WrapTable>
        <NewTable bordered hover>
          <Header>
            <tr style={ { fontFamily: 'Gotham', borderBottom: '2px solid #EEEEEE' } }>
              {
                time_sheet_approval_header.map((h) =>
                  (<HeadTable
                    key={ shortid() }
                    onClick={ () => this.handleClickSort(h.value) }
                  >
                    { h.label }
                    { h.value === sort_column && (
                      sort_order && h.value === sort_column ?
                        <Icon src={ arrow_up_black } alt="logo" />
                        :
                        <Icon src={ arrow_down_black } alt="logo" />
                    )
                    }
                  </HeadTable>)
                )}
            </tr>
          </Header>
          <BodyTable>
            {
              this.sortTimesheetApproval(timesheetApprovals).map((approval, key) => {
                const createdDate = get(approval, 'created')
                const createdDateString = createdDate ? moment(createdDate).format('DD-MM-YYYY HH:mm:SS') : '-'
                return (
                  <tr
                    key={ shortid() }
                    style={ { cursor: 'pointer', hover: '#E5E5E5', backgroundColor: (key % 2 === 0) ? '#FFFFFF' : '#FFF8F8' } }
                    onClick={ () => handleClickRow(approval._id) }
                  >
                    <td>
                      <div style={ { display: 'flex', color: statusColor(get(approval, 'my_status')) } }>
                        <Circle color={ statusColor(get(approval, 'my_status')) } />
                        { get(approval, 'my_status') }
                      </div>
                    </td>
                    <td>
                      <div style={ { display: 'flex', color: statusColor(get(approval, 'status')) } }>
                        <Circle color={ statusColor(get(approval, 'status')) } />
                        { approveStatus(get(approval, 'status')) }
                      </div>
                    </td>
                    <td>{ get(approval, 'month') }</td>
                    <td>{ get(approval, 'year') }</td>
                    <td>{ get(approval, 'emp_code') }</td>
                    <td>{ `${get(approval, 'first_name')} ${get(approval, 'last_name')} (${get(approval, 'nick_name')})` }</td>
                    <td>{ get(approval, 'lob_name') }</td>
                    <td>{ get(approval, 'department_name') }</td>
                    <td>{ createdDateString }</td>
                  </tr>
                )
              })
            }
          </BodyTable>
        </NewTable>
      </WrapTable>
    )
  }
}

ApprovalTable.propTypes = {
  timesheets: PropTypes.object,
  handleClickRow: PropTypes.func,
  searchApproval: PropTypes.string,
}
ApprovalTable.defaultProps = {
  timesheets: {},
  handleClickRow: () => {},
  searchApproval: '',
}

const NewTable = styled(Table)`
  background: white;
  thead{
    display:table;
    width:100%;
    table-layout:fixed;
    font-family: ${FONTS.GOTHAM_MEDIUM} !important;
    font-size: ${FONTS.SMALL_SIZE};
    background-color: #ffffff ;
  }tbody tr{
    display:table;
    width:100%;
    table-layout:fixed;
    font-family: ${FONTS.GOTHAM} !important;
    font-size: ${FONTS.SMALL_SIZE};
    border-bottom: 1px solid #cccccc;
  }thead th{
    border: none ;
    font-size: ${FONTS.SMALL_SIZE};
  }tbody td{
    border: none ;
    font-size: ${FONTS.SMALL_SIZE};
    word-wrap: break-word;
  }
`
const WrapTable = styled.div`
  padding-top: 10;
  padding-right: 15px;
  font-family: ${FONTS.GOTHAM} ;
`
const BodyTable = styled.tbody`
  width: 100%;
  display: block;
  max-height: calc(100vh - 230px);
  overflow-y: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`
const HeadTable = styled.th`
  color: #000000;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
`
const Icon = styled.img`
  width : 5%;
  margin-left: 5%;
  cursor: pointer;
`
const Header = styled.thead`
  background: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
`
const Circle = styled.div`
  height: 8px;
  width: 8px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  margin-right: 5px;
  margin-bottom: auto;
  margin-top: auto;
`




// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/timesheet-approval/table.js